import { denormalize } from "normalizr";
import { folderOffersSchema } from "features/common/schemas";

export const getFolderOffers = (state, documentId, siteId) => {
  const projection = state.document.decision.folderOffers[`${documentId}-${siteId}`];
  const decision = state.entities.decision[`${documentId}-${siteId}`]
    ? state.entities.decision[`${documentId}-${siteId}`].folderOffers
    : [];
  if (projection && projection.loaded) {
    const folderOffers = denormalize(decision, [folderOffersSchema], state.entities);
    return folderOffers;
  }
  return [];
};
